<section class="survey-form u-margin-top-small  u-margin-bottom-medium max-width">

    <label for="" class="form-header-label" [ngStyle]="{'color':commentcardStyles.MainContentTextColor}">{{'Commentcardsubtitle' | translate}}</label>
    <div class="form">
        <div class="question-card" *ngFor="let question of questions; let index= index;" [ngStyle]="{'border-color':commentcardStyles.CommentCardBackgroundColor}">
            <div class="question-card__question u-margin-bottom-small" [ngStyle]="{'color':commentcardStyles.CommentCardTextColor, 'border-color':commentcardStyles.CommentCardTextColor}"><span *ngIf="index+1 != questions.length">{{index
                    + 1}}. </span>{{question.Question}}</div>
            <div class="question-card__answer">
                <div class="question-card__rating" *ngIf="question.type === 'rating'" (click)="checkaallselected()">
                    <button type="button" mat-button *ngFor="let option of question.options;"
                        [matTooltip]="option.label" matTooltipClass="custom-tooltip-bottom"
                        class="question-card__rate-item" (click)="question.rating = option.rating">
                        <span class="icon-fill">
                            <mat-icon aria-hidden="false" [ngStyle]="{'color':commentcardStyles.StarBackgroundColor}" aria-label="rating" *ngIf="question.rating >= option.rating">
                                star</mat-icon>
                        </span>
                        <span class="icon-empty">
                            <mat-icon aria-hidden="false" aria-label="rating" *ngIf="question.rating < option.rating">
                                star_border</mat-icon>
                        </span>

                    </button>
                </div>
                <div class="question-card__choice"></div>
                <div *ngIf="question.type === 'text'" class="question-card__text" [ngStyle]="{'color':commentcardStyles.CommentCardTextColor}">
                    <mat-label>{{'Commentcardfreetext' | translate}}</mat-label>
                    <mat-form-field appearance="outline" class="form__input" floatLabel="never">
                       <!-- <input [(ngModel)]="question.value" (input)="onSearchChange($event.target.value)" matInput [placeholder]="'Commentcardfreetext' | translate">-->
                        <textarea [(ngModel)]="question.value" (input)="onSearchChange($event.target.value)" matInput [placeholder]="'Commentcardfreetext' | translate" rows="3"></textarea>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="form__footer u-margin-top-small">
            <button class="btn-submit" [disabled]="isdatavalid" [ngStyle]="{'background-color': (isdatavalid ? commentcardStyles.ButtonLinkColor : 0 )}" mat-flat-button color="warn" type="submit"
                (click)="submit()">Submit</button>
            <button mat-stroked-button type="button" (click)="reload()">Cancel</button>
        </div>
    </div>
</section>